module.exports = __webpack_public_path__ + "img/ico_kpt.ccf5070b.png";